<template>
  <div/>
  <div
    class="infocenterItem"
    @click="onClick"
    :tabindex="pValue.onClick ? 0 : -1"
    :role="pValue.onClick ? 'button' : ''"
  >
    <div>
      <dtpIcon left :name="pValue.categoryIcon" v-if="pValue.categoryIcon !== ''" />
      {{ pValue.category }} - {{ getTime() }}
    </div>
    <div class="title">
      <!--  Replace-regexet erstatter alle html-tags der måtte være i pValue.title med en tom streng. -->
      <span v-html="pValue.title.replace(/<\/?[^>]+(>|$)/g, '')"/>
      <dtpIcon
        size="sm"
        right
        :name="pValue.titleIcon"
        v-if="pValue.titleIcon !== ''"
        style="vertical-align: top"
      />
    </div>
    <div class="subtitle" v-if="pValue.subtitle !== ''">
      {{ pValue.subtitle }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import filters from "./filters/Filters";
import { IInfoCenterItem, InfoCenterItem } from "./IstInfoCenterItem";

defineOptions({ name: "IstInfoCenterItem" });

const props = withDefaults(defineProps<{ modelValue?: any }>(), { modelValue: null });
const pValue = ref<IInfoCenterItem>(new InfoCenterItem());

onMounted(() => {
  pValue.value = props.modelValue;
});

watch(
  () => props.modelValue,
  (value) => {
    pValue.value = value as IInfoCenterItem;
  }
);

const onClick = () => {
  if (pValue.value.onClick) {
    pValue.value.onClick();
  }
};

const getTime = () => {
  return filters.timedistance(pValue.value.time);
};
</script>

<style scoped lang="scss">
@import "../assets/variables";

.infocenterItem {
  padding: 4px 12px;
  user-select: none;
  color: $ist-blue;

  &:hover::before {
    transform: scale(1);
    opacity: 0.12;
  }

  &::before {
    content: "";
    display: block;
    opacity: 0;
    position: absolute;
    transition-duration: 0.15s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    z-index: -1;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    background: currentColor;
    transform: scale(0);
    margin: 0;
    padding: 14px;
    transition-property: transform, opacity;
  }

  & .subtitle {
    color: #00000099;
    font-size: 0.8em;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }

  & .title {
    color: #000000;
    font-size: 1.1em;
    width: 100%;
    max-height: 54px;
    padding: 6px 0 12px 0;
    overflow: hidden;
    display: block;

    & span {
      width: calc(100% - 41px);
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>
